export enum ReportViewPageKeys {
  reportsView_reportsBreadcrumb = "reportsView_reportsBreadcrumb",
  reportsView_lastUpdatedString = "reportsView_lastUpdatedString",
  reportsView_totalString = "reportsView_totalString",
  reportsView_completedString = "reportsView_completedString",
  reportsView_cancelledString = "reportsView_cancelledString",
  reportsView_completionRateString = "reportsView_completionRateString",
  reportsView_groupReportTab = "reportsView_groupReportTab",
  reportsView_individualsReportTab = "reportsView_individualsReportTab",
  reportsView_teamReportTab = "reportsView_teamReportTab",
  reportsView_clearButton = "reportsView_clearButton",
  reportsView_selectFromListBelow = "reportsView_selectFromListBelow",
  reportsView_invalidSurveyCampaign = "reportsView_invalidSurveyCampaign",
}
